<template>
  <div>
    <div class="dev-toolbar">
      <span class="dev-toolbar__badge">DEV MODE</span>
      <label class="dev-toolbar__label">遊戲類型：</label>
      <select v-model="selectedGame" @change="resetGame" class="dev-toolbar__select">
        <option value="capsule">扭蛋 (CapsuleToy)</option>
        <option value="slot">拉霸 (SlotMachine)</option>
        <option value="chouqian">抽籤 (ChouqianHooks)</option>
        <option value="scratch">刮刮卡 (ScratchOff)</option>
        <option value="winwheel">幸運輪盤 (WinWheel)</option>
      </select>
    </div>
    <GamePage
      v-if="showGame"
      gameId="mock-game-dev-001"
      userId="mock-user-dev-001"
      platform="web"
      :isModuleChannel="false"
      :mockData="currentMockData"
    />
  </div>
</template>

<script>
import GamePage from './GamePage.vue'
import { mockGames } from '../mock/index.js'

export default {
  name: 'DevWrapper',
  components: { GamePage },
  data() {
    return {
      selectedGame: this.$route.query.game || 'capsule',
      showGame: true,
    }
  },
  computed: {
    currentMockData() {
      return mockGames[this.selectedGame]
    },
  },
  methods: {
    resetGame() {
      this.showGame = false
      this.$nextTick(() => {
        this.showGame = true
      })
    },
  },
}
</script>

<style scoped>
.dev-toolbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: #1a1a2e;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  font-size: 13px;
  font-family: monospace;
}
.dev-toolbar__badge {
  background: #ff4757;
  color: #fff;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: bold;
  font-size: 11px;
  letter-spacing: 0.5px;
}
.dev-toolbar__label {
  color: #a8b2c1;
}
.dev-toolbar__select {
  background: #2d2d44;
  color: #fff;
  border: 1px solid #444;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 13px;
  cursor: pointer;
}
</style>
